const defaultFiscalComponentsState = () => ({
  issExibilityCollection: [],
  taxRegimeCollection: [],
  nbsCollection: [],
  nfseNatureCodesCollection: [],
  nfseNatureOfOperationCollection: [],
  responsibleRetentionCollection: [],
  cfopCollection: [],
});

const initialState = {
  ...defaultFiscalComponentsState(),
};

export default {
  ...initialState,
  modalDiscountLimit: false,
};
